// import React, { useState } from "react";
// import TextField from "@mui/material/TextField";
// import Button from "@mui/material/Button";
// import { LOGIN } from "../../utils/app-routes";
// import { useAuth } from "../../services/auth/AuthContext";
// import Loader from "../loader/loader";
// import { Divider, Snackbar } from "@mui/material";
// import PasswordField from "../password-field/password-field";

// interface FormData {
//   email: string;
//   firstName: string;
//   secondName: string;
//   password: string;
//   confirmPassword: string;
// }

// interface RegistrationFormProps {
//   onConfirm: (email: string) => void;
//   handleConfirmationCode: () => void;
// }

// const RegistrationForm: React.FC<RegistrationFormProps> = ({
//   onConfirm,
//   handleConfirmationCode,
// }) => {
//   const { singUp } = useAuth();
//   const [loading, setLoading] = useState(false);
//   const [snackBarOpen, setSnackBarOpen] = useState(false);
//   const [snackMessage, setSnackMessage] = useState("");
//   const [formData, setFormData] = useState<FormData>({
//     email: "",
//     firstName: "",
//     secondName: "",
//     password: "",
//     confirmPassword: "",
//   });

//   const [errors, setErrors] = useState<Partial<FormData>>({});

//   // Función para validar el correo electrónico
//   const validateEmail = (email: string) => {
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     return emailRegex.test(email);
//   };

//   // Función para validar nombres (solo letras y espacios)
//   const validateName = (name: string) => {
//     const nameRegex = /^[a-zA-ZÀ-ÿ\s'-]+$/;
//     return nameRegex.test(name);
//   };

//   // Función para validar la contraseña
//   const validatePassword = (password: string) => {
//     const errors = [];
//     if (password.length < 6) {
//       errors.push("La contraseña debe tener al menos 6 caracteres.");
//     }
//     if (!/[a-z]/.test(password)) {
//       errors.push("Debe contener al menos una letra minúscula.");
//     }
//     if (!/[A-Z]/.test(password)) {
//       errors.push("Debe contener al menos una letra mayúscula.");
//     }
//     if (!/[0-9]/.test(password)) {
//       errors.push("Debe contener al menos un número.");
//     }
//     if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
//       errors.push("Debe contener al menos un carácter especial.");
//     }
//     return errors.length > 0 ? errors.join(" ") : null;
//   };

//   const handleSubmit = async (e: React.FormEvent) => {
//     setLoading(true);
//     e.preventDefault();

//     let tempErrors: Partial<FormData> = {};

//     // Validación del correo electrónico
//     if (!formData.email) {
//       tempErrors.email = "El correo electrónico es requerido.";
//     } else if (!validateEmail(formData.email)) {
//       tempErrors.email = "El correo electrónico no es válido.";
//     }

//     // Validación del primer nombre
//     if (!formData.firstName) {
//       tempErrors.firstName = "El nombre es requerido.";
//     } else if (!validateName(formData.firstName)) {
//       tempErrors.firstName = "El nombre solo puede contener letras y espacios.";
//     }

//     // Validación del segundo nombre
//     if (!formData.secondName) {
//       tempErrors.secondName = "El apellido es requerido.";
//     } else if (!validateName(formData.secondName)) {
//       tempErrors.secondName =
//         "El apellido solo puede contener letras y espacios.";
//     }

//     // Validación de la contraseña
//     const passwordError = validatePassword(formData.password);
//     if (!formData.password) {
//       tempErrors.password = "La contraseña es requerida.";
//     } else if (passwordError) {
//       tempErrors.password = passwordError;
//     }

//     // Validación de confirmación de contraseña
//     if (!formData.confirmPassword) {
//       tempErrors.confirmPassword = "Por favor confirma tu contraseña.";
//     } else if (formData.password !== formData.confirmPassword) {
//       tempErrors.confirmPassword = "Las contraseñas no coinciden.";
//     }

//     setErrors(tempErrors);

//     if (Object.keys(tempErrors).length === 0) {
//       const userAttributes = {
//         email: formData.email,
//         phone_number: "11111111",
//         given_name: formData.firstName,
//         family_name: formData.secondName,
//       };
//       const response = await singUp(
//         formData.email,
//         formData.password,
//         userAttributes
//       );

//       if (response) {
//         onConfirm(formData.email);
//       } else {
//         setSnackMessage(
//           "Ha ocurrido un error. Por favor, intente nuevamente más tarde"
//         );
//         setSnackBarOpen(true);
//       }
//     }
//     setLoading(false);
//   };

//   const handlePassword = (value: string) => {
//     setFormData({ ...formData, ["password"]: value });
//     setErrors({ ...errors, ["password"]: "" });
//   };

//   const handleConfirmPassword = (value: string) => {
//     setFormData({ ...formData, ["confirmPassword"]: value });
//     setErrors({ ...errors, ["confirmPassword"]: "" });
//   };

//   const handleChange = (e: any) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//     setErrors({ ...errors, [e.target.name]: "" });
//   };

//   // Verificar si todos los campos están llenos y no hay errores
//   const isFormValid =
//     Object.values(formData).every((value) => value.trim() !== "") &&
//     Object.values(errors).every((error) => error === "");

//   const snackBar = () => {
//     return (
//       <Snackbar
//         anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
//         open={snackBarOpen}
//         onClose={() => setSnackBarOpen(false)}
//         message={snackMessage}
//         autoHideDuration={3000}
//         key="snackbar-register"
//       />
//     );
//   };

//   return (
//     <form className="max-w-md mx-auto p-4" onSubmit={handleSubmit}>
//       <TextField
//         label="Correo Electrónico"
//         name="email"
//         type="email"
//         value={formData.email}
//         onChange={handleChange}
//         error={Boolean(errors.email)}
//         helperText={errors.email}
//         fullWidth
//         margin="normal"
//       />
//       <TextField
//         label="Nombre"
//         name="firstName"
//         value={formData.firstName}
//         onChange={handleChange}
//         error={Boolean(errors.firstName)}
//         helperText={errors.firstName}
//         fullWidth
//         margin="normal"
//       />
//       <TextField
//         label="Apellido"
//         name="secondName"
//         value={formData.secondName}
//         onChange={handleChange}
//         error={Boolean(errors.secondName)}
//         helperText={errors.secondName}
//         fullWidth
//         margin="normal"
//       />
//       {/* <TextField
//         label="Contraseña"
//         name="password"
//         type="password"
//         value={formData.password}
//         onChange={handleChange}
//         error={Boolean(errors.password)}
//         helperText={errors.password}
//         fullWidth
//         margin="normal"
//       /> */}
//       <br />
//       <div className="w-full mb-3 mt-3">
//         <PasswordField
//           isConfirm
//           name="password"
//           id="1"
//           value={formData.password}
//           onChange={handlePassword}
//           label="Contraseña"
//           error={Boolean(errors.password)}
//           helperText={errors.password}
//         />
//       </div>
//       <div className="w-full mb-3">
//         <PasswordField
//           name="confirmPassword"
//           id="2"
//           isConfirm
//           value={formData.confirmPassword}
//           onChange={handleConfirmPassword}
//           error={Boolean(errors.confirmPassword)}
//           helperText={errors.confirmPassword}
//           label="Confirmar Contraseña"
//         />
//       </div>

//       {/* <TextField
//         label="Confirmar Contraseña"
//         name="confirmPassword"
//         type="password"
//         value={formData.confirmPassword}
//         onChange={handleChange}
//         error={Boolean(errors.confirmPassword)}
//         helperText={errors.confirmPassword}
//         fullWidth
//         margin="normal"
//       /> */}
//       {loading && (
//         <div className="w-full mb-3 mt-3">
//           <Loader />
//         </div>
//       )}
//       {!loading && (
//         <Button
//           type="submit"
//           variant="contained"
//           color="primary"
//           className="mt-4 w-full"
//           disabled={!isFormValid}
//         >
//           Registrarse
//         </Button>
//       )}
//       <Button disabled={loading} className="m-3 w-full" href={LOGIN}>
//         Iniciar sesión
//       </Button>
//       <Divider className="w-full margin">
//         ¿Ya tienes un código de verificación?
//       </Divider>
//       <Button className="m-3 w-full" onClick={() => handleConfirmationCode()}>
//         Ingresar código de verificación
//       </Button>
//       {snackBar()}
//     </form>
//   );
// };

// export default RegistrationForm;

import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { LOGIN } from "../../utils/app-routes";
import { useAuth } from "../../services/auth/AuthContext";
import Loader from "../loader/loader";
import {
  Divider,
  Snackbar,
  Checkbox,
  FormControlLabel,
  Typography,
  Link,
  FormHelperText,
  Box,
} from "@mui/material";
import PasswordField from "../password-field/password-field";

interface FormData {
  email: string;
  firstName: string;
  secondName: string;
  password: string;
  confirmPassword: string;
}

interface RegistrationFormProps {
  onConfirm: (email: string) => void;
  handleConfirmationCode: () => void;
}

const RegistrationForm: React.FC<RegistrationFormProps> = ({
  onConfirm,
  handleConfirmationCode,
}) => {
  const { singUp } = useAuth();
  const [loading, setLoading] = useState(false);
  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [formData, setFormData] = useState<FormData>({
    email: "",
    firstName: "",
    secondName: "",
    password: "",
    confirmPassword: "",
  });

  const [errors, setErrors] = useState<Partial<FormData>>({});

  // >>> NUEVO: consentimiento
  const [consent, setConsent] = useState(false);
  const [consentTouched, setConsentTouched] = useState(false);
  const consentError = consentTouched && !consent;

  // Validaciones existentes
  const validateEmail = (email: string) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const validateName = (name: string) => /^[a-zA-ZÀ-ÿ\s'-]+$/.test(name);
  const validatePassword = (password: string) => {
    const msgs = [];
    if (password.length < 6)
      msgs.push("La contraseña debe tener al menos 6 caracteres.");
    if (!/[a-z]/.test(password))
      msgs.push("Debe contener al menos una letra minúscula.");
    if (!/[A-Z]/.test(password))
      msgs.push("Debe contener al menos una letra mayúscula.");
    if (!/[0-9]/.test(password)) msgs.push("Debe contener al menos un número.");
    if (!/[!@#$%^&*(),.?\":{}|<>]/.test(password))
      msgs.push("Debe contener al menos un carácter especial.");
    return msgs.length ? msgs.join(" ") : null;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    let tempErrors: Partial<FormData> = {};

    if (!formData.email) {
      tempErrors.email = "El correo electrónico es requerido.";
    } else if (!validateEmail(formData.email)) {
      tempErrors.email = "El correo electrónico no es válido.";
    }

    if (!formData.firstName) {
      tempErrors.firstName = "El nombre es requerido.";
    } else if (!validateName(formData.firstName)) {
      tempErrors.firstName = "El nombre solo puede contener letras y espacios.";
    }

    if (!formData.secondName) {
      tempErrors.secondName = "El apellido es requerido.";
    } else if (!validateName(formData.secondName)) {
      tempErrors.secondName =
        "El apellido solo puede contener letras y espacios.";
    }

    const passwordError = validatePassword(formData.password);
    if (!formData.password) {
      tempErrors.password = "La contraseña es requerida.";
    } else if (passwordError) {
      tempErrors.password = passwordError;
    }

    if (!formData.confirmPassword) {
      tempErrors.confirmPassword = "Por favor confirma tu contraseña.";
    } else if (formData.password !== formData.confirmPassword) {
      tempErrors.confirmPassword = "Las contraseñas no coinciden.";
    }

    setErrors(tempErrors);
    setConsentTouched(true);

    // Si faltan campos/errores o no hay consentimiento, no continuar
    const hasFieldErrors = Object.keys(tempErrors).length > 0;
    if (hasFieldErrors || !consent) {
      if (!consent) {
        setSnackMessage("Debes aceptar el consentimiento para continuar.");
        setSnackBarOpen(true);
      }
      setLoading(false);
      return;
    }

    // Signup
    const userAttributes = {
      email: formData.email,
      phone_number: "11111111",
      given_name: formData.firstName,
      family_name: formData.secondName,
    };
    const response = await singUp(
      formData.email,
      formData.password,
      userAttributes
    );

    if (response) {
      onConfirm(formData.email);
    } else {
      setSnackMessage(
        "Ha ocurrido un error. Por favor, intente nuevamente más tarde"
      );
      setSnackBarOpen(true);
    }
    setLoading(false);
  };

  const handlePassword = (value: string) => {
    setFormData({ ...formData, ["password"]: value });
    setErrors({ ...errors, ["password"]: "" });
  };

  const handleConfirmPassword = (value: string) => {
    setFormData({ ...formData, ["confirmPassword"]: value });
    setErrors({ ...errors, ["confirmPassword"]: "" });
  };

  const handleChange = (e: any) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  // Todos llenos + sin errores + consentimiento
  const isFormValid =
    Object.values(formData).every((v) => v.trim() !== "") &&
    Object.values(errors).every((err) => err === "") &&
    consent;

  const snackBar = () => (
    <Snackbar
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      open={snackBarOpen}
      onClose={() => setSnackBarOpen(false)}
      message={snackMessage}
      autoHideDuration={3000}
      key="snackbar-register"
    />
  );

  return (
    <form className="max-w-md mx-auto p-4" onSubmit={handleSubmit}>
      <TextField
        label="Correo Electrónico"
        name="email"
        type="email"
        value={formData.email}
        onChange={handleChange}
        error={Boolean(errors.email)}
        helperText={errors.email}
        fullWidth
        margin="normal"
      />
      <TextField
        label="Nombre"
        name="firstName"
        value={formData.firstName}
        onChange={handleChange}
        error={Boolean(errors.firstName)}
        helperText={errors.firstName}
        fullWidth
        margin="normal"
      />
      <TextField
        label="Apellido"
        name="secondName"
        value={formData.secondName}
        onChange={handleChange}
        error={Boolean(errors.secondName)}
        helperText={errors.secondName}
        fullWidth
        margin="normal"
      />

      <br />
      <div className="w-full mb-3 mt-3">
        <PasswordField
          isConfirm
          name="password"
          id="1"
          value={formData.password}
          onChange={handlePassword}
          label="Contraseña"
          error={Boolean(errors.password)}
          helperText={errors.password}
        />
      </div>
      <div className="w-full mb-3">
        <PasswordField
          name="confirmPassword"
          id="2"
          isConfirm
          value={formData.confirmPassword}
          onChange={handleConfirmPassword}
          error={Boolean(errors.confirmPassword)}
          helperText={errors.confirmPassword}
          label="Confirmar Contraseña"
        />
      </div>

      {/* >>> NUEVO: Checkbox de consentimiento */}
      <Box mt={1} mb={1}>
        <FormControlLabel
          control={
            <Checkbox
              checked={consent}
              onChange={(e) => setConsent(e.target.checked)}
              onBlur={() => setConsentTouched(true)}
              color="primary"
            />
          }
          label={
            <Typography variant="body2" color="text.secondary">
              Doy mi consentimiento para que la aplicación utilice los datos que
              proporciono con el fin de crear mi cuenta y brindarme los
              servicios de notificación ofrecidos.
            </Typography>
          }
        />
        {consentError && (
          <FormHelperText error>
            Debes aceptar el consentimiento para continuar.
          </FormHelperText>
        )}
      </Box>

      {loading && (
        <div className="w-full mb-3 mt-3">
          <Loader />
        </div>
      )}
      {!loading && (
        <Button
          type="submit"
          variant="contained"
          color="primary"
          className="mt-4 w-full"
          disabled={!isFormValid}
        >
          Registrarse
        </Button>
      )}
      <Button disabled={loading} className="m-3 w-full" href={LOGIN}>
        Iniciar sesión
      </Button>
      <Divider className="w-full margin">
        ¿Ya tienes un código de verificación?
      </Divider>
      <Button className="m-3 w-full" onClick={() => handleConfirmationCode()}>
        Ingresar código de verificación
      </Button>

      {snackBar()}
    </form>
  );
};

export default RegistrationForm;
